import React from "react";

/**
 * Tiny inline SVG payment-method badges. No external assets, no licensing risk.
 * Brand-aligned monochrome on dark or light backgrounds via `dark` prop.
 */
const Badge = ({ children, label, dark }) => (
  <div
    aria-label={label}
    title={label}
    className={`inline-flex items-center justify-center h-7 w-11 border ${
      dark ? "bg-white/5 border-white/15 text-gray-200" : "bg-white border-gray-200 text-[#0a0a0a]"
    }`}
  >
    {children}
  </div>
);

const PaymentIcons = ({ dark = false }) => {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="payment-icons">
      <Badge dark={dark} label="Visa">
        <span className="text-[10px] font-bold italic tracking-tight">VISA</span>
      </Badge>
      <Badge dark={dark} label="Mastercard">
        <span className="flex items-center gap-0.5">
          <span className="h-3 w-3 rounded-full bg-[#eb001b]" />
          <span className="h-3 w-3 rounded-full bg-[#f79e1b] -ml-1.5 mix-blend-multiply" />
        </span>
      </Badge>
      <Badge dark={dark} label="American Express">
        <span className="text-[9px] font-bold tracking-tight">AMEX</span>
      </Badge>
      <Badge dark={dark} label="Discover">
        <span className="text-[8.5px] font-bold tracking-tight">DISC</span>
      </Badge>
      <Badge dark={dark} label="Apple Pay">
        <span className="text-[9px] font-semibold">Pay</span>
      </Badge>
      <Badge dark={dark} label="Google Pay">
        <span className="text-[9px] font-semibold">G Pay</span>
      </Badge>
      <Badge dark={dark} label="Stripe">
        <span className="text-[9px] font-semibold italic">stripe</span>
      </Badge>
    </div>
  );
};

export default PaymentIcons;
